module.exports = __webpack_public_path__ + "img/44.cd8e436f.jpg";